import { render, staticRenderFns } from "./DeletePatient.vue?vue&type=template&id=57c3c8e5&scoped=true&"
import script from "./DeletePatient.vue?vue&type=script&lang=ts&"
export * from "./DeletePatient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c3c8e5",
  null
  
)

export default component.exports